// src/components/ui/Icons.jsx
// Set de íconos SVG inline, estilo "line icons" minimalista (tipo Lucide/Feather).
// Todos heredan color via currentColor para adaptarse al contexto dorado/púrpura.
import React from 'react';

const baseProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '1.75',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

/** Cartas de tarot — dos cartas superpuestas */
export const TarotCardsIcon = (props) => (
  <svg {...baseProps} {...props}>
    <rect x="3" y="6" width="10" height="15" rx="1.5" transform="rotate(-8 8 13.5)" />
    <rect x="9" y="4" width="10" height="15" rx="1.5" />
    <path d="M14 8.5v0" />
    <circle cx="14" cy="9.5" r="1.4" />
  </svg>
);

/** Libro / guía */
export const BookIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z" />
    <path d="M9 7h7" />
    <path d="M9 11h5" />
  </svg>
);

/** Birrete de graduación — cursos */
export const GraduationCapIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M2 9.5 12 5l10 4.5-10 4.5-10-4.5Z" />
    <path d="M6.5 11.7v4.3c0 1.4 2.46 2.5 5.5 2.5s5.5-1.1 5.5-2.5v-4.3" />
    <path d="M21 9.5v6" />
  </svg>
);

/** Diario / journal — cuaderno con lápiz */
export const JournalIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M5 3.5A1.5 1.5 0 0 1 6.5 2H17a1.5 1.5 0 0 1 1.5 1.5V21l-3-2-3 2-3-2-3 2V3.5Z" />
    <path d="M8.5 8h6" />
    <path d="M8.5 11.5h6" />
  </svg>
);

/** Rueda zodiacal — círculo con marcas radiales */
export const ZodiacWheelIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
    <path d="M12 3v4" />
    <path d="M12 17v4" />
    <path d="M3 12h4" />
    <path d="M17 12h4" />
    <path d="M5.6 5.6l2.8 2.8" />
    <path d="M15.6 15.6l2.8 2.8" />
    <path d="M18.4 5.6l-2.8 2.8" />
    <path d="M8.4 15.6l-2.8 2.8" />
  </svg>
);

/** Regalo — referidos */
export const GiftIcon = (props) => (
  <svg {...baseProps} {...props}>
    <rect x="3" y="8.5" width="18" height="4.2" rx="0.8" />
    <path d="M5 12.7V21h14v-8.3" />
    <path d="M12 8.5V21" />
    <path d="M12 8.5C10.5 5.5 8 5 7 6c-1 1-.3 2.5 1 2.5H12Z" />
    <path d="M12 8.5C13.5 5.5 16 5 17 6c1 1 .3 2.5-1 2.5H12Z" />
  </svg>
);

/** Candado — privacidad */
export const LockIcon = (props) => (
  <svg {...baseProps} {...props}>
    <rect x="4.5" y="10.5" width="15" height="10" rx="1.8" />
    <path d="M7.5 10.5V7a4.5 4.5 0 0 1 9 0v3.5" />
    <path d="M12 14.5v3" />
  </svg>
);

/** Robot / IA */
export const RobotIcon = (props) => (
  <svg {...baseProps} {...props}>
    <rect x="4" y="9" width="16" height="11" rx="2.2" />
    <path d="M12 5.5v3.5" />
    <circle cx="12" cy="4" r="1.3" fill="currentColor" stroke="none" />
    <circle cx="9" cy="14.2" r="1.2" fill="currentColor" stroke="none" />
    <circle cx="15" cy="14.2" r="1.2" fill="currentColor" stroke="none" />
    <path d="M9 17.5h6" />
    <path d="M2 13v3" />
    <path d="M22 13v3" />
  </svg>
);

/** Estrella */
export const StarIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M12 3.2 14.6 9l6.4.6-4.8 4.2 1.4 6.2L12 16.9 6.4 20l1.4-6.2L3 9.6 9.4 9 12 3.2Z" />
  </svg>
);

/** Destello / sparkle (para tiradas / eyebrow) */
export const SparkleIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M12 3v4" />
    <path d="M12 17v4" />
    <path d="M3 12h4" />
    <path d="M17 12h4" />
    <path d="M12 8.2 13.4 11l2.8 1.4-2.8 1.4L12 16.6 10.6 13.8 7.8 12.4l2.8-1.4L12 8.2Z" />
  </svg>
);

/** Llave — mi cuenta */
export const KeyIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="7.5" cy="14.5" r="4" />
    <path d="M10.5 11.7 19 3.2" />
    <path d="M15.5 7.2 18 9.7" />
    <path d="M18.2 4.5 20.7 7" />
  </svg>
);

/** Varita mágica — herramientas interactivas */
export const WandIcon = (props) => (
  <svg {...baseProps} {...props}>
    <path d="M4 20 15.5 8.5" />
    <path d="M13.5 6.5 17.5 10.5" />
    <path d="M19 3v3" />
    <path d="M19 9v3" />
    <path d="M22 6h-3" />
    <path d="M16 6h-3" />
  </svg>
);

/** Lupa — usada en buscadores (disponible por consistencia futura) */
export const SearchIcon = (props) => (
  <svg {...baseProps} {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);
